import { IAdpVoucherHolder } from '@nkr/models/index';
import { AdpVoucherPrintStatus } from '@nkr/enums/index';

interface IProps {
    voucherHolder: IAdpVoucherHolder,
    userId: number,
    onVoucherHolderAction: (voucherHolderId: number, currentStatus: AdpVoucherPrintStatus) => void
}

const VoucherHolderRow = (props: IProps) => {
    const handleVoucherHolderAction = () => {
        let { id, printStatus } = props.voucherHolder;
        props.onVoucherHolderAction(id, printStatus);
    };

    const renderVoucherHolderActionButton = () => {
        let { voucherHolder } = props;
        let buttonWidth: number = 150;
        let hasAlreadyClickedMarkSent1 = voucherHolder.certificateFirstCheckUserId == props.userId;

        switch (voucherHolder.printStatus) {
            case AdpVoucherPrintStatus.WaitingConsentFile:
                return <button className='btn btn-xs btn-basic' onClick={handleVoucherHolderAction} style={{ width: buttonWidth }} disabled>Waiting for Consent</button>;

            case AdpVoucherPrintStatus.WaitingScreeningFile:
                return <button className='btn btn-xs btn-basic' onClick={handleVoucherHolderAction} style={{ width: buttonWidth }} disabled>Waiting for Screening</button>;

            case AdpVoucherPrintStatus.WaitingSwabFile:
                return <button className='btn btn-xs btn-basic' onClick={handleVoucherHolderAction} style={{ width: buttonWidth }} disabled>Waiting for Swab</button>;

            case AdpVoucherPrintStatus.ReadyToPrint:
                return <button className='btn btn-xs btn-success' onClick={handleVoucherHolderAction} style={{ width: buttonWidth }}>Print Voucher</button>;

            case AdpVoucherPrintStatus.Printed:
                return <button className='btn btn-xs btn-primary' onClick={handleVoucherHolderAction} style={{ width: buttonWidth }}>User 1 - Mark Sent</button>;

            case AdpVoucherPrintStatus.MarkSentUser1:
                return <button className='btn btn-xs btn-warning' onClick={handleVoucherHolderAction} style={{ width: buttonWidth }} disabled={hasAlreadyClickedMarkSent1}>User 2 - Mark Sent</button>;

            case AdpVoucherPrintStatus.MarkSentUser2:
                return <button className='btn btn-xs btn-secondary' style={{ width: buttonWidth }} disabled>Sent</button>;
        }
    };

    const { voucherHolder } = props;

    return (
        <tr>
            <td style={{ textAlign: 'center' }}></td>
            <td style={{ textAlign: 'center' }}></td>
            <td style={{ textAlign: 'center' }}></td>
            <td style={{ textAlign: 'center' }}>{voucherHolder.donorRegistrationDate}</td>
            <td style={{ textAlign: 'center' }}></td>
            <td style={{ textAlign: 'center' }}>{voucherHolder.fullName}</td>
            <td style={{ textAlign: 'center' }}>{voucherHolder.age}</td>
            <td style={{ textAlign: 'center' }}>{voucherHolder.type}</td>
            <td style={{ textAlign: 'center' }}>{renderVoucherHolderActionButton()}</td>
        </tr>
    );
}

export default VoucherHolderRow;